import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import MediaDetailBanner from './MediaDetailBanner'
import MediaDetailContent from './MediaDetailContent'
import MediaCTA from './MediaCTA'
import ErrorPage from '../../errorPage/ErrorPage'
import { BaseUrl } from '../../../helper/BaseUrl'

export default function MediaDetail({ initialData }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [news, setNews] = useState(
    initialData && !Array.isArray(initialData) ? initialData : {}
  );
  const notFound = Boolean(initialData?.notFound);

  useEffect(() => {
    if (initialData?.notFound) return undefined;
    if (initialData?.slug === slug) return undefined;
    let active = true;
    setNews({});

    fetch(`${BaseUrl}/api/news/view/${encodeURIComponent(slug)}`)
      .then(async (response) => {
        const result = await response.json().catch(() => ({}));
        if (!active) return;
        if (!response.ok || !result?.news) {
          navigate("/404", { replace: true });
          return;
        }
        setNews(result.news);
      })
      .catch((error) => {
        console.error("Unable to fetch media detail:", error.message);
        if (active) navigate("/404", { replace: true });
      });
    return () => {
      active = false;
    };
  }, [initialData, navigate, slug]);

  if (notFound) return <ErrorPage />;

  return (
    <>
      <MediaDetailBanner data={news} />
      <MediaDetailContent data={news} />
      <MediaCTA />
    </>
  )
}
